export const FEATURE_NAME = '@vshosting/cdn/core/alias-base';

